export default __webpack_public_path__ + "static/media/gitcommits.b44c1180.png";